export default "__VITE_ASSET__dGgQuk61__"